@if (showEmptyPage) {
  <div class="nothing-to-show">
    <i class="fa fa-4x fa-sitemap"></i>
    <p>{{"No devices connected" | translate}}</p>
  </div>
}
